import { useSnapshot } from 'valtio';

import Notice from '@cartwhl/ui/molecules/Notice';

import { noticesStore } from 'stores/global';

export default function Notices() {
  const { notices } = useSnapshot(noticesStore.state);

  return (
    <div
      style={{ top: `72px` }}
      className="pointer-events-none fixed left-0 z-100 w-full px-4"
    >
      {notices.map((notice) => (
        <Notice
          key={notice.id}
          removeCallback={() => noticesStore.remove(notice.id)}
          {...notice}
        />
      ))}
    </div>
  );
}
